import React, { useState } from "react";
import { Formik } from "formik";

const initialValues = {
  status: "",
  searchIP: "",
  searchUser: "",
};

export function AccessLogFilter({ filterValues, myRef }) {
  const applyFilter = (values) => {
    filterValues(values);
  };
  const [accessLog, setAccessLog] = useState(initialValues);
  return (
    <>
      <Formik
        initialValues={accessLog}
        onSubmit={(values) => {
          applyFilter(values);
          console.log(values);
        }}
        onReset={values => {
          console.log("Hello shankar", values);
          applyFilter(values);
        }}
      >
        {({
          values,
          handleSubmit,
          handleBlur,
          handleChange,
          setFieldValue,
          handleReset
        }) => (
          <form onSubmit={handleSubmit} className="form form-label-right">
            <div className="form-group row">
              <div className="col-lg-2">
                <select
                  className="form-control"
                  name="status"
                  placeholder="Filter by status Type"
                  onChange={(e) => {
                    setFieldValue("status", e.target.value);
                    handleSubmit();
                  }}
                  onBlur={handleBlur}
                  value={values.status}
                >
                  <option value="">All</option>
                  <option value="GET">GET</option>
                  <option value="POST">POST</option>
                  <option value="PATCH">PATCH</option>
                  <option value="DELETE">DELETE</option>
                  <option value="PUT">PUT</option>
                </select>
                <small className="form-text text-muted">
                  Filter by <b>Method</b>
                </small>
              </div>
              <div className="col-lg-2">
                <input
                  type="text"
                  className="form-control"
                  name="searchIP"
                  placeholder="IP"
                  onBlur={handleBlur}
                  value={values.searchIP}
                  onChange={(e) => {
                    setFieldValue("searchIP", e.target.value);
                    handleSubmit();
                  }}
                />
                <small className="form-text text-muted">
                  Search by <b>IP</b>
                </small>
              </div>
              <div className="col-lg-2">
                <input
                  type="text"
                  className="form-control"
                  name="searchUser"
                  placeholder="User Name"
                  onBlur={handleBlur}
                  value={values.searchUser}
                  onChange={(e) => {
                    setFieldValue("searchUser", e.target.value);
                    handleSubmit();
                  }}
                />
                <small className="form-text text-muted">
                  Search by <b>User</b>
                </small>
              </div>
              <div className="col-lg-2">
                <button
                  className="btn btn-white-primary"
                  onClick={handleReset}
                  ref={myRef}
                  style={{ display: "none" }}
                ></button>
              </div>
            </div>
          </form>
        )}
      </Formik>
    </>
  );
}
